import { StrategyType, AltsAllocation } from "@/types/investment";
import { AssetClass } from "@/types/portfolio";
import { ASSET_CLASS_COLORS } from "@/constants/investmentColors";

// Asset class default allocations per strategy
export const defaultAssetAllocations: Record<StrategyType, Record<string, number>> = {
  preservation: {
    stocks_allocation: 20,
    bonds_allocation: 40,
    cash_allocation: 30,
    alts_allocation: 10
  },
  income: {
    stocks_allocation: 30,
    bonds_allocation: 40,
    cash_allocation: 15,
    alts_allocation: 15
  },
  growth: {
    stocks_allocation: 50,
    bonds_allocation: 20,
    cash_allocation: 10,
    alts_allocation: 20
  },
  diversification: {
    stocks_allocation: 40,
    bonds_allocation: 30,
    cash_allocation: 10,
    alts_allocation: 20
  },
  custom: {
    stocks_allocation: 0,
    bonds_allocation: 0,
    cash_allocation: 0,
    alts_allocation: 0
  }
};

// Default asset classes with colors from central color management
export const defaultAssetClasses: AssetClass[] = [
  { name: "Stocks", value: 60, color: ASSET_CLASS_COLORS.equity },
  { name: "Bonds", value: 40, color: ASSET_CLASS_COLORS.fixed_income },
  { name: "Cash", value: 0, color: ASSET_CLASS_COLORS.cash },
  { name: "Alternatives", value: 0, color: ASSET_CLASS_COLORS.alternative }
];

// Alternative investment allocations per strategy
export const getDefaultAllocations = (strategy: StrategyType): AltsAllocation => {
  const defaultValues: Record<StrategyType, AltsAllocation> = {
    preservation: {
      private_equity_allocation: 0,
      private_credit_allocation: 20,
      private_debt_allocation: 20,
      real_estate_allocation: 30,
      hedge_funds_allocation: 10,
      commodities_allocation: 15,
      cryptocurrencies_allocation: 0,
      collectibles_allocation: 5
    },
    income: {
      private_equity_allocation: 0,
      private_credit_allocation: 25,
      private_debt_allocation: 10,
      real_estate_allocation: 25,
      hedge_funds_allocation: 25,
      commodities_allocation: 0,
      cryptocurrencies_allocation: 0,
      collectibles_allocation: 15
    },
    growth: {
      private_equity_allocation: 30,
      private_credit_allocation: 10,
      private_debt_allocation: 5,
      real_estate_allocation: 20,
      hedge_funds_allocation: 15,
      commodities_allocation: 10,
      cryptocurrencies_allocation: 5,
      collectibles_allocation: 5
    },
    diversification: {
      private_equity_allocation: 15,
      private_credit_allocation: 15,
      private_debt_allocation: 10,
      real_estate_allocation: 20,
      hedge_funds_allocation: 20,
      commodities_allocation: 10,
      cryptocurrencies_allocation: 5,
      collectibles_allocation: 5
    },
    custom: {
      private_equity_allocation: 12.5,
      private_credit_allocation: 12.5,
      private_debt_allocation: 12.5,
      real_estate_allocation: 12.5,
      hedge_funds_allocation: 12.5,
      commodities_allocation: 12.5,
      cryptocurrencies_allocation: 12.5,
      collectibles_allocation: 12.5
    }
  };

  return defaultValues[strategy];
};